import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../MainBlog.css';

const markdownList = require('../markdownList.json');

const sortMarkdown = (list) =>
  [...list]
    .sort((a, b) => {
      const getNums = (title) => {
        const s = title.match(/S(\d+)/i);
        const p = title.match(/(\d+)(?:\.(\d+))?\.?\s*Kısım/i);
        return {
          season: s ? parseInt(s[1], 10) : 1,
          part: p ? parseInt(p[1], 10) : 0,
          sub: p && p[2] ? parseInt(p[2], 10) : 0,
        };
      };
      const A = getNums(a.title);
      const B = getNums(b.title);
      return A.season - B.season || A.part - B.part || A.sub - B.sub;
    })
    .reverse();

const sortedMarkdownList = sortMarkdown(markdownList);
const specialSlugs = ['ustun-zekalar2-9-1', 'ustun-zekalar2-9-2'];

const removeZero = (slug) => slug.replace(/-(0\d+)$/, (match, p1) => `-${p1.replace(/^0+/, '')}`);

const CHARACTERS = [
  {
    group: 'Karakterler',
    title: 'Üstün Zekalar',
    items: [
      { name: 'Mecnun', role: 'Eski lider' },
      { name: 'Furkan' },
      { name: 'Emre' },
      { name: 'Zeyo' },
      { name: 'Ensar' },
      { name: 'Senyao' },
      { name: 'Turkish' },
      { name: 'Dark' },
      { name: 'Gölge', role: 'Lider' },
    ],
  },
  {
    group: 'Karakterler',
    title: 'KAH Yönetimi',
    items: [
      { name: 'Sertaç Abi', role: 'KAH Hükümdarı' },
      { name: 'Hawli', role: 'Yönetici' },
      { name: 'Olmeyen_Hortum', role: 'Yönetici' },
      { name: 'Chezzy', role: 'Has' },
      { name: 'Kevkeb', role: 'Has' },
      { name: 'Hido', role: 'Has' },
      { name: 'Dark' },
      { name: 'Kireyzi', role: 'Has' },
    ],
  },
  {
    group: 'Karakterler',
    title: 'Klanlar',
    items: [
      { name: 'Furkan' },
      { name: 'Chezzy', role: 'FWR' },
      { name: 'Pwillop', role: 'FWR' },
      { name: 'Dark', role: 'ALPHA-FWR' },
    ],
  },
  {
    group: 'Karakterlerr',
    title: 'Yeni KAH Yönetimi',
    items: [
      { name: 'Gölge', role: 'Lider' },
      { name: 'Chezzy' },
      { name: 'Kevkeb' },
      { name: 'Pwillop' },
      { name: 'Kireyzi' },
      { name: 'Zeyo' },
      { name: 'Senyao' },
      { name: 'Mee6', role: 'R' },
    ],
  },
  {
    group: 'Karakterlerr',
    title: 'Üstün Zekalar',
    items: [
      { name: 'Mecnun', role: 'Eski lider' },
      { name: 'Furkan' },
      { name: 'Emre' },
      { name: 'Ensar' },
      { name: 'Turkish' },
      { name: 'Dark' },
    ],
  },
  {
    group: 'Karakterlerr',
    title: 'KAH Yönetimi',
    items: [
      { name: 'Sertaç Abi', role: 'KAH Hükümdarı' },
      { name: 'Hawli', role: 'Yönetici' },
      { name: 'Olmeyen_Hortum', role: 'Yönetici' },
      { name: 'Hido', role: 'Has' },
      { name: 'Dark' },
    ],
  },
  {
    group: 'Karakterlerr',
    title: 'KAH Sakinleri',
    items: [
      { name: 'Mei Yuzuru', role: 'R' },
      { name: 'Sinek-BOT', role: 'R' },
    ],
  },
  {
    group: 'Karakterlerr',
    title: 'Klanlar',
    items: [
      { name: 'Furkan' },
      { name: 'Chezzy', role: 'FWR' },
      { name: 'Pwillop', role: 'FWR' },
      { name: 'Dark', role: 'ALPHA-FWR' },
    ],
  },
];

class HomePage extends Component {
  state = {
    ratings: {},
    views: {},
    activeTab: 'Bölümler',
    showSpecialsOnly: false,
  };

  componentDidMount() {
    this.fetchRatings();
    this.fetchViews();
  }

  changeTab = (tab) => {
    if (tab === 'Karakterlerr') {
      if (window.confirm('Spoiler uyarısı! Güncel karakter listesi spoiler içermektedir.')) {
        this.setState({ activeTab: tab });
      }
    } else this.setState({ activeTab: tab });
  };

  // Bölüm puanlarını API'den alır
  fetchRatings = async () => {
    try {
      const ratings = await Promise.all(
        markdownList.map(async (post) => {
          const response = await fetch(`https://darknight-api.vercel.app/rating?slug=${removeZero(post.slug)}`);
          const data = await response.json();
          return { slug: post.slug, rating: data.averageRating };
        })
      );
      this.setState({
        ratings: Object.fromEntries(ratings.map(({ slug, rating }) => [slug, rating])),
      });
    } catch (error) {
      console.error('Puanları alırken hata:', error);
    }
  };

  // Her bölüm için görüntülenme sayısını alır
  fetchViews = async () => {
    try {
      const views = await Promise.all(
        markdownList.map(async (post) => {
          const response = await fetch(`https://darknight-api.vercel.app/views?slug=${removeZero(post.slug)}`);
          const data = await response.json();
          return { slug: post.slug, totalViews: data.totalViews };
        })
      );
      this.setState({
        views: Object.fromEntries(views.map(({ slug, totalViews }) => [slug, totalViews])),
      });
    } catch (error) {
      console.error('Görüntülenme sayısı alınırken hata:', error);
    }
  };

  renderCharacterGroups = (group) =>
    CHARACTERS.filter((g) => g.group === group).map(({ title, items }) => (
      <section className="chars-group" key={title}>
        <h2 className="chars-title">{title}</h2>
        <ul className="chars-list">
          {items.map(({ name, role }) => (
            <li className="chars-item" key={name}>
              <span className="chars-name">{name}</span>
              {role && <span className="chars-role">{role}</span>}
            </li>
          ))}
        </ul>
      </section>
    ));

  render() {
    const { ratings, views, activeTab, showSpecialsOnly } = this.state;
    const tabs = ['Bölümler', 'Karakterler'];

    const s2Posts = sortedMarkdownList.filter(({ title }) => title.includes('S2'));
    const firstS2PostSlug = s2Posts.length ? s2Posts[0].slug : null;
    const lastS2PostSlug = s2Posts.length ? s2Posts[s2Posts.length - 1].slug : null;

    const visiblePosts = sortedMarkdownList
      .filter(({ slug }) => !slug.includes('taslak'))
      .filter(({ slug }) => !showSpecialsOnly || specialSlugs.includes(slug));

    const listItems = [];
    visiblePosts.forEach((post) => {
      if (post.slug === firstS2PostSlug) listItems.push({ type: 'divider', text: 'İkinci Sezon' });
      listItems.push({ type: 'post', post });
      if (post.slug === lastS2PostSlug) listItems.push({ type: 'divider', text: 'İlk Sezon' });
    });

    return (
      <div className="homepage">
        <div className="container">
          <header className="hero">
            <span className="hero-eyebrow">DarkNight'tan</span>
            <h1 className="hero-title">
              Üstün Zekalar
              <span className="hero-sub">Kah&rsquo;ın Gölgesinde</span>
            </h1>
            <span className="season-badge">3. Sezon</span>
          </header>

          <nav className="tabs">
            {tabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => this.changeTab(tab)}
                className={`tab-btn${activeTab === tab ? ' active' : ''}`}
              >
                {tab}
              </button>
            ))}
          </nav>

          {activeTab === 'Bölümler' && (
            <main className="section">
              <div
                className="special-notice"
                onClick={() => this.setState((prev) => ({ showSpecialsOnly: !prev.showSpecialsOnly }))}
              >
                {showSpecialsOnly ? '✕ Tüm Bölümleri Göster' : '★ Özel Bölümler aşağıda — görmek için tıkla ★'}
              </div>

              <div className="post-list">
                {listItems.map((item, index) =>
                  item.type === 'divider' ? (
                    <div className="season-divider" key={`divider-${index}`}>
                      {item.text}
                    </div>
                  ) : (
                    <Link
                      to={`/${item.post.slug}`}
                      className={`post-card${specialSlugs.includes(item.post.slug) ? ' special' : ''}`}
                      key={item.post.slug}
                    >
                      <div className="post-meta">
                        <span className="meta-item">
                          <span className="meta-star">{ratings[item.post.slug] ? '★' : '☆'}</span>
                          {ratings[item.post.slug] || '0.00'}
                        </span>
                        <span className="meta-item">
                          <span className="meta-eye">{views[item.post.slug] ? '👁️' : '💀'}</span>
                          {views[item.post.slug] || 0} kişi okudu
                        </span>
                      </div>

                      <h2 className="post-title">{item.post.title}</h2>

                      <p className="post-summary">{item.post.summary}</p>
                    </Link>
                  )
                )}
              </div>

              <p className="update-note">— Her hafta yeni bölüm!!!</p>
            </main>
          )}

          {activeTab === 'Karakterler' && (
            <main className="section">
              <div className="chars-grid">{this.renderCharacterGroups('Karakterler')}</div>
              <button type="button" className="spoiler-link" onClick={() => this.changeTab('Karakterlerr')}>
                Güncel Listeyi Gör
              </button>
            </main>
          )}

          {activeTab === 'Karakterlerr' && (
            <main className="section">
              <div className="chars-grid">{this.renderCharacterGroups('Karakterlerr')}</div>
              <button type="button" className="spoiler-link" onClick={() => this.changeTab('Karakterler')}>
                Eski Listeye Dön
              </button>
            </main>
          )}
        </div>
      </div>
    );
  }
}

export default HomePage;
